import React from 'react'
import withRedux from 'next-redux-wrapper'
import { Actions as AlgoliaActions } from 'actions/algolia2/data'
import { algoliaCollectionApi } from 'apis/algolia'
import Theme from 'components/Theme'
import { Actions as PageActions } from 'actions/page'
import { App, Store } from 'apps/public/shows'
import { getMetaData } from 'apps/public/shows/selectors/metadata'
import { storeSetup } from 'lib/pageSetup'
const { ALGOLIA_ENV, APP_ENV } = process.env
const algoliaEnv = ALGOLIA_ENV || APP_ENV || 'production'
const defaultIndice = `${algoliaEnv}_artwork_in_collections`
const hitsPerPage = 1000

const Shows = (): React.ReactElement<React.ComponentProps<any>, any> => (
  <Theme>
    <App />
  </Theme>
)

const setupShowsData = async ({ algoliaSetup, destinationZone }: Record<string, any>) => {
  try {
    // Configuration Data
    const { facets, slugifyDictionary, collectionId } = algoliaSetup
    const algoliaResults = await algoliaCollectionApi({
      hitsPerPage,
      query: collectionId,
      restrictSearchableAttributes: 'collection_id',
      typoTolerance: false,
      searchIndice: defaultIndice,
      destinationZone,
    })
    // Expect to Match ALGOLIA Reducer - Initial Setup
    return {
      data: algoliaResults,
      facets: facets || {},
      hitsPerPage,
      selectedFacets: {
        collectionTypes: 'Community',
      },
      sharedFacetNames: {},
      slugifyDictionary: slugifyDictionary || {},
    }
  } catch (error) {
    console.error('setupAASelectionData', {
      error,
    })
    return {}
  }
}

Shows.getInitialProps = async ({ res, req, store, query }): Record<string, any> => {
  // Client-Side
  if (!req) {
    return {}
  }

  // SSR
  storeSetup(store, req)
  // Set PAGE data passed from Express Route
  store.dispatch(PageActions.SET(query.page))
  const { destinationZone } = req
  // Fetch Algolia data
  const { algoliaSetup } = query
  const algoliaData = await setupShowsData({
    algoliaSetup,
    destinationZone,
  })
  const { data } = algoliaData
  store.dispatch(AlgoliaActions.INITIAL_SETUP(algoliaData))
  store.dispatch(
    PageActions.SET_DATA({
      algoliaResults: data,
    })
  )
  // Metadata & Datalayer
  const state = { ...store.getState() }
  const metaData = getMetaData(state)
  return {
    dataLayer: {
      event: 'pagetype',
      pagetype: 'Shows',
    },
    metaData,
  }
}

export default withRedux(Store)(Shows)